import cx from 'classnames';
import Link from 'next/link';
import React from 'react';
import HideFromUser from 'src/components-v2/Helpers/HideFromUser/HideFromUser';
import Context from '../../../contexts/docs';
import Image from '../Image';
import { withTrailingSlash } from '../utilities';
import styles from './ProductCard.module.scss';

interface Props {
  title: string;
  subtitle: string;
  link: string;
  src: string;
}

const ProductCard: React.FC<Props> = (props: Props) => {
  const { dispatch } = React.useContext(Context);

  const handleClick = (e) => {
    // We can keep the event logic here for ProductCards since we control the markup directly
    dispatch({
      type: 'CARD_CLICKED',
      payload: {
        cardType: 'product',
        title: props.title,
        linkPath: props.link,
      },
    });
  };

  return (
    <>
      <div className={cx(styles.productCardWrapper, 'hide-for-aeo')}>
        <Link
          href={withTrailingSlash(props.link)}
          className={styles.card}
          onClick={handleClick}
        >
          <Image className={styles.icon} src={props.src} alt='' />
          <div className={styles.text}>
            <h4 className={styles.productCardTitle}>{props.title}</h4>
            <p className={styles.productCardSubtitle}>{props.subtitle}</p>
          </div>
        </Link>
      </div>
      <HideFromUser>
        <h4>{props.title}</h4>
        <p>
          <a href={withTrailingSlash(props.link)}>{props.subtitle}</a>
        </p>
      </HideFromUser>
    </>
  );
};

ProductCard.displayName = 'ProductCard';

export default ProductCard;
